import { useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import { currencyList } from "./SetCurrency";


export function AmountFormatter(amount: string, currency: string) {

    if(amount.length < 3) amount = amount.padStart(3, '0');
    const amountFormatted = amount?.slice(0, amount.length - 2) + ',' + amount?.slice(amount.length - 2);
    const currentAmount = amount ? amountFormatted : 0;
    const [currentCurrency, setCurrentCurrency] = useState<string>('€')

    useEffect(() => {
        const findedCurrency: string | undefined = currencyList.find((currencyOp) => currencyOp.value === currency)?.symbol;
        setCurrentCurrency(findedCurrency ? findedCurrency : '€')
    }, [currency])

    return (
        <>
            <NumberFormat className="ml-2 mr-1" thousandSeparator={'.'} decimalSeparator={','} decimalScale={2} value={currentAmount} fixedDecimalScale={true} displayType='text' />
            {currentCurrency}
        </>
    )
}